import { Dialog } from "@mui/material";
import React from "react";
import NotesContentPreivew from "../GlobalFeature/Table/ExtraComponent/NotesContentPreivew";

function NotesPreviewDialog({ open, onClose, info, fullWidth, maxWidth }) {
  return (
    <Dialog open={open} onClose={onClose} fullWidth={fullWidth} maxWidth={maxWidth}>
      <NotesContentPreivew notesData={[info]} HandlePreviewData={onClose} />
    </Dialog>
  );
}

export default NotesPreviewDialog;
